/**
 * Centralized API Endpoints Export
 * Framework-agnostic - works in Angular, React, Vue, etc.
 *
 * Structure:
 * - config.ts       → Base URLs, environment config
 * - common/         → Shared endpoints (auth, uploads) - used by both apps
 * - hubadmin/       → HubAdmin-specific endpoints
 * - superadmin/     → SuperAdmin-specific endpoints
 */

// ============================================
// BASE CONFIGURATION
// ============================================
export * from './config';
export {
  API_BASE_URL,
  API_BASE_URLS,
  ACTIVE_ENVIRONMENT,
  FILE_DOWNLOAD_BASE_URL,
  FILE_DOWNLOAD_BASE_URLS,
  IMAGE_URL,
  COM_MATRIX_URL,
} from './config';

// ============================================
// COMMON ENDPOINTS (Shared by both apps)
// ============================================
export * from './common';
export { AUTH_ENDPOINTS } from './common/auth.endpoints';

// ============================================
// HUBADMIN ENDPOINTS
// ============================================
export * from './hubadmin';
export {
  // Master Data
  MASTER_DATA_ENDPOINTS,
  REGION_ENDPOINTS,
  STATE_ENDPOINTS,
  CITY_ENDPOINTS,
  BRAND_CATEGORY_ENDPOINTS,
  BRAND_ENDPOINTS,
  LANGUAGE_ENDPOINTS,
  UNIT_ENDPOINTS,
  BANNER_ENDPOINTS,
  VENDOR_ENDPOINTS,
  FREQUENCY_ENDPOINTS,
  CYCLE_ENDPOINTS,
  QUARTER_ENDPOINTS,
  DELIVERY_PARTNER_ENDPOINTS,
  // User Management
  ROLE_ENDPOINTS,
  ROLE_SETTINGS_ENDPOINTS,
  USER_ENDPOINTS,
  ENTITY_ENDPOINTS,
  USER_SUPERVISOR_MAPPING_ENDPOINTS,
  DEACTIVATE_USERS_ENDPOINTS,
  SUPERVISOR_SPLIT_ASSIGN_ENDPOINTS,
  RESET_BANK_DETAILS_ENDPOINTS,
  BULK_DEACTIVATE_END_ROLE_ENDPOINTS,
  // Schemes
  SCHEMES_ENDPOINTS,
  // Target Achievements
  TARGET_ACHIEVEMENTS_ENDPOINTS,
  POINT_STRUCTURE_ENDPOINTS,
  TARGET_ENDPOINTS,
  TARGET_QUARTER_ENDPOINTS,
  TARGET_CYCLE_ENDPOINTS,
  BRANDS_ENDPOINTS,
  ACHIEVEMENTS_ENDPOINTS,
  MAKER_CHECKER_ENDPOINTS,
  // TDS
  TDS_ENDPOINTS,
  // Engagement
  ENGAGEMENT_ENDPOINTS,
  USER_ROLE_ENDPOINTS,
  CONFIG_ENDPOINTS,
  // Rewards
  REWARDS_ENDPOINTS,
  REWARD_CATEGORY_ENDPOINTS,
  INSTANT_VOUCHER_ENDPOINTS,
  REWARD_PRODUCT_ENDPOINTS,
  HELP_DESK_ENDPOINTS,
  INVOICE_UPLOAD_ENDPOINTS,
  // Settings
  SETTINGS_ENDPOINTS,
  FAQ_ENDPOINTS,
  PRIVACY_POLICY_ENDPOINTS,
  TERMS_CONDITION_ENDPOINTS,
  BRAND_ZONE_ENDPOINTS,
} from './hubadmin';

// ============================================
// SUPERADMIN ENDPOINTS
// ============================================
export * from './superadmin';
export { PROGRAMS_ENDPOINTS } from './superadmin/programs.endpoints';
export { FULFILLMENT_ENDPOINTS } from './superadmin/fulfillment.endpoints';
export {
  ABOUT_PROGRAM_ENDPOINTS,
  SUPERADMIN_REGIONS_ENDPOINTS,
  GEO_GROUPS_ENDPOINTS,
  USER_TYPE_ENDPOINTS,
  USER_GROUPS_ENDPOINTS,
  BRAND_SKU_ENDPOINTS,
  COMMUNICATION_ENDPOINTS,
  SECURITY_ENDPOINTS,
  REPORTS_ENDPOINTS,
} from './superadmin/configuration.endpoints';
